import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { canAccessModulePath, canAccessPath, getDefaultPathForModules, getUserRoles, ROLES } from '../utils/permissions';
import { useModules } from '../contexts/ModuleContext';

function ProtectedRoute({ children }) {
  const { token } = useContext(AuthContext);
  const location = useLocation();
  const { modules, loading } = useModules();

  if (!token) {
    return <Navigate to="/login" />;
  }

  if (loading) return <div className="d-flex justify-content-center align-items-center min-vh-100"><div className="spinner-border text-success" /></div>;

  const roles = getUserRoles(token);
  const rotaPlataformaPermitida = ['/assinaturas', '/novidades-admin', '/novidades']
    .some((rota) => location.pathname.startsWith(rota));
  if (roles.includes(ROLES.PLATFORM_ADMIN) && !rotaPlataformaPermitida) {
    return <Navigate to="/assinaturas" replace />;
  }

  if (!canAccessPath(location.pathname, roles)) {
    return <Navigate to={roles.includes(ROLES.PLATFORM_ADMIN) ? '/assinaturas' : '/menu'} replace />;
  }

  if (!roles.includes(ROLES.PLATFORM_ADMIN) && !canAccessModulePath(location.pathname, modules)) {
    return <Navigate to={getDefaultPathForModules(modules)} replace />;
  }

  return children;
}

export default ProtectedRoute;
